<template>
  <div
    class="layout-cell-container scroller"
    :class="[isDragover ? 'isDrag-over' : '', isActiveCell ? 'active-layout-cell-container' : '']"
    @drop.stop="drop2"
    @dragover.prevent="dragoverEv"
    @dragleave.prevent="dragoverLeaveEv"
    @click.stop="clickLayoutCol"
    :style="{...bgStyle, ...zIndexControl, ...getAutoLayoutContentStyle(0), ...this.getOverStyle}"
  >
    <!--    ToDo  拖拽手柄-->
    <span class="handle-move" style="position:absolute;left:0;top:0;display:inline-block;width: 100%;height:100%;z-index: 0"></span>
    <!--loading效果-->
    <div class="loading-wrap">
      <div class="loading-rect-box">
        <span class="icon icon-portal-loading1"></span>
        <p>模块加载中</p>
      </div>
    </div>
    <div v-if="cellData.length === 0 && !isBigScreenPreview() && showEmptyTip && layoutSize" class="empty-rect-tip">
      <p >从左侧工具栏拖拽添加模块</p>
    </div>
    <template v-else-if="isAccordionLayout">
      <div class="accordionContent open" :class="index === openIndex ? '' : 'hidden'" :style="getAutoLayoutContentStyle(index === openIndex)">
        <VueDragResizable
          @click.stop
          v-if="showComponent(rect) && rect.options.isOpenState"
          v-for="(rect, index) in cellData"
          :key="rect.rect_id"
          :class="[
            judgeIsFullRect(rect),
            `container_id_${id}-rect_id_${rect.rect_id}`,
            rect.active && !isElementInLayout ? 'active' : '',
            dragging && insertIndex - 1 === index && (insertIndex - 1 > activeIndex || insertIndex - 1 === activeIndex) ? 'ghost after' : dragging && insertIndex - 1 === index && insertIndex - 1 < activeIndex ? 'ghost before' : ''
          ]"
          :options="rect.options"
          :w="checkAndSetVal(rect.options, 'width', 'width', 20, { container_id: id, rect_id: rect.rect_id })"
          :h="checkAndSetVal(rect.options, 'height', 'height', 20, { container_id: id, rect_id: rect.rect_id })"
          :x="Number(checkAndSetVal(rect.options, 'left', 'left', 1, { container_id: id, rect_id: rect.rect_id }))"
          :y="Number(checkAndSetVal(rect.options, 'top', 'top', 1, { container_id: id, rect_id: rect.rect_id }))"
          :parentW="Number(getParentW)"
          :parentH="Number(getParentH)"
          :parent="true"
          :active="rect.active && !isElementInLayout"
          :draggable="getDraggable(rect)"
          :resizable="checkResizable(rect)"
          :handles="checkHandles(rect)"
          :z="rect.zIndex"
          :rectId="rect.rect_id"
          :containerId="id"
          :snapWithAdsorbent="true"
          :shape="rect.shape"
          :swiperMode="rect.options.swiperMode"
          :zoom="zoom"
          :isShowModuleHandles="showModuleHandles"
          v-on:delElement="delElementEv"
          v-on:activated="activateEv(id, rect.rect_id, rect.shape, index)"
          v-on:deactivated="deactivateEv(id, rect.rect_id, rect.shape)"
          @swiperModeChange="handleSwiperMode($event, id, rect.rect_id)"
          v-on:mouse-down="mouseDownEv($event, id, rect.rect_id)"
          v-on:dragging="draggingEv(arguments, id, rect.rect_id)"
          v-on:dragStop="dragStopEv(arguments, id, rect.rect_id)"
          v-on:dragStatuChange="moduleHandlesStatuChange($event)"
          v-on:resizing="changeSize($event, id, rect.rect_id, false, rect)"
          v-on:resizeStop="changeSize($event, id, rect.rect_id, true, rect)"
          @refLineParams="getRefLineParams"
          @reRender="checkExcute"
          :style="getSpecialStyle(rect)"
          :myId="{ rect_id: rect.rect_id, container_id: id }"
          :forbiden="forbidActive"
        >
          <div
            class="vdr_shade"
            :class="[rect.options.leftType === '%' || rect.options.topType === '%' ? 'no-drag' : '']"
            v-if="
              !rect.active &&
              (ids.rect_id !== rect.rect_id || ids.container_id !== id) &&
              !$store.state.states.leftMenuDragStatus &&
              rect.shape !== 'cxPageLayoutComponent' &&
              !isBigScreenPreview() &&
              rect.shape !== 'cxTabs'
            "
          ></div>
          <component
            :zoom="zoom"
            :rect="rect"
            :active="rect.active && !isElementInLayout"
            :options="rect.options"
            :parentOptions="parentElement"
            :rectheight="Number(rect.height)"
            :myid="{ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId }"
            :class="[
              'rect',
              rect.options.animateSets && rect.options.animateSets.animateType !== 0 ? 'animate__animated' : '',
              rect.options.animateSets && rect.options.animateSets.executionAnimateClass
                ? rect.options.animateSets.animateClass
                : ''
            ]"
            :style="bigScreenAnimateStyle(rect.options)"
            :is="rect.shape === 'emptyLayoutComponent' ? 'layoutComponent' : rect.shape"
          ></component>
        </VueDragResizable>
      </div>
      <div class="accordionContent default" :class="index !== openIndex ? '' : 'hidden'"  :style="getAutoLayoutContentStyle(index !== openIndex)">
        <VueDragResizable
          @click.stop
          v-if="showComponent(rect) && !rect.options.isOpenState"
          v-for="(rect, index) in cellData"
          :key="rect.rect_id"
          :class="[
            judgeIsFullRect(rect),
            `container_id_${id}-rect_id_${rect.rect_id}`,
            rect.active && !isElementInLayout ? 'active' : '',
            dragging && insertIndex - 1 === index && (insertIndex - 1 > activeIndex || insertIndex - 1 === activeIndex) ? 'ghost after' : dragging && insertIndex - 1 === index && insertIndex - 1 < activeIndex ? 'ghost before' : ''
          ]"
          :options="rect.options"
          :w="checkAndSetVal(rect.options, 'width', 'width', 20, { container_id: id, rect_id: rect.rect_id })"
          :h="checkAndSetVal(rect.options, 'height', 'height', 20, { container_id: id, rect_id: rect.rect_id })"
          :x="Number(checkAndSetVal(rect.options, 'left', 'left', 1, { container_id: id, rect_id: rect.rect_id }))"
          :y="Number(checkAndSetVal(rect.options, 'top', 'top', 1, { container_id: id, rect_id: rect.rect_id }))"
          :parentW="Number(getParentW)"
          :parentH="Number(getParentH)"
          :parent="true"
          :active="rect.active && !isElementInLayout"
          :draggable="getDraggable(rect)"
          :resizable="checkResizable(rect)"
          :handles="checkHandles(rect)"
          :z="rect.zIndex"
          :rectId="rect.rect_id"
          :containerId="id"
          :snapWithAdsorbent="true"
          :shape="rect.shape"
          :swiperMode="rect.options.swiperMode"
          :zoom="zoom"
          :isShowModuleHandles="showModuleHandles"
          v-on:delElement="delElementEv"
          v-on:activated="activateEv(id, rect.rect_id, rect.shape, index)"
          v-on:deactivated="deactivateEv(id, rect.rect_id, rect.shape)"
          @swiperModeChange="handleSwiperMode($event, id, rect.rect_id)"
          v-on:mouse-down="mouseDownEv($event, id, rect.rect_id)"
          v-on:dragging="draggingEv(arguments, id, rect.rect_id)"
          v-on:dragStop="dragStopEv(arguments, id, rect.rect_id)"
          v-on:dragStatuChange="moduleHandlesStatuChange($event)"
          v-on:resizing="changeSize($event, id, rect.rect_id, false, rect)"
          v-on:resizeStop="changeSize($event, id, rect.rect_id, true, rect)"
          @refLineParams="getRefLineParams"
          @reRender="checkExcute"
          :style="getSpecialStyle(rect)"
          :myId="{ rect_id: rect.rect_id, container_id: id }"
          :forbiden="forbidActive"
        >
          <div
            class="vdr_shade"
            :class="[rect.options.leftType === '%' || rect.options.topType === '%' ? 'no-drag' : '']"
            v-if="
              !rect.active &&
              (ids.rect_id !== rect.rect_id || ids.container_id !== id) &&
              !$store.state.states.leftMenuDragStatus &&
              rect.shape !== 'cxPageLayoutComponent' &&
              !isBigScreenPreview() &&
              rect.shape !== 'cxTabs'
            "
          ></div>
          <component
            :zoom="zoom"
            :rect="rect"
            :active="rect.active && !isElementInLayout"
            :options="rect.options"
            :parentOptions="parentElement"
            :rectheight="Number(rect.height)"
            :myid="{ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId }"
            :class="[
              'rect',
              rect.options.animateSets && rect.options.animateSets.animateType !== 0 ? 'animate__animated' : '',
              rect.options.animateSets && rect.options.animateSets.executionAnimateClass
                ? rect.options.animateSets.animateClass
                : ''
            ]"
            :style="bigScreenAnimateStyle(rect.options)"
            :is="rect.shape === 'emptyLayoutComponent' ? 'layoutComponent' : rect.shape"
          ></component>
        </VueDragResizable>
      </div>
    </template>
    <template v-else>
    <VueDragResizable
      @click.stop
      v-if="!renderCurrentTabData || showComponent(rect)"
      v-for="(rect, index) in cellData"
      :key="rect.rect_id"
      :class="[
        judgeIsFullRect(rect),
        `container_id_${id}-rect_id_${rect.rect_id}`,
        rect.active && !isElementInLayout ? 'active' : '',
        dragging && insertIndex - 1 === index && (insertIndex - 1 > activeIndex || insertIndex - 1 === activeIndex) ? 'ghost after' : dragging && insertIndex - 1 === index && insertIndex - 1 < activeIndex ? 'ghost before' : ''
      ]"
      :options="rect.options"
      :w="checkAndSetVal(rect.options, 'width', 'width', 20, { container_id: id, rect_id: rect.rect_id })"
      :h="checkAndSetVal(rect.options, 'height', 'height', 20, { container_id: id, rect_id: rect.rect_id })"
      :x="Number(checkAndSetVal(rect.options, 'left', 'left', 1, { container_id: id, rect_id: rect.rect_id }))"
      :y="Number(checkAndSetVal(rect.options, 'top', 'top', 1, { container_id: id, rect_id: rect.rect_id }))"
      :parentW="Number(getParentW)"
      :parentH="Number(getParentH)"
      :parent="true"
      :active="rect.active && !isElementInLayout"
      :draggable="getDraggable(rect)"
      :resizable="checkResizable(rect)"
      :handles="checkHandles(rect)"
      :z="rect.zIndex"
      :rectId="rect.rect_id"
      :containerId="id"
      :snapWithAdsorbent="true"
      :shape="rect.shape"
      :swiperMode="rect.options.swiperMode"
      :zoom="zoom"
      :isShowModuleHandles="showModuleHandles"
      v-on:delElement="delElementEv"
      v-on:activated="activateEv(id, rect.rect_id, rect.shape, index)"
      v-on:deactivated="deactivateEv(id, rect.rect_id, rect.shape)"
      @swiperModeChange="handleSwiperMode($event, id, rect.rect_id)"
      v-on:mouse-down="mouseDownEv($event, id, rect.rect_id)"
      v-on:dragging="draggingEv(arguments, id, rect.rect_id)"
      v-on:dragStop="dragStopEv(arguments, id, rect.rect_id)"
      v-on:dragStatuChange="moduleHandlesStatuChange($event)"
      v-on:resizing="changeSize($event, id, rect.rect_id, false, rect)"
      v-on:resizeStop="changeSize($event, id, rect.rect_id, true, rect)"
      @refLineParams="getRefLineParams"
      @reRender="checkExcute"
      :style="getSpecialStyle(rect)"
      :myId="{ rect_id: rect.rect_id, container_id: id }"
      :forbiden="forbidActive"
    >
      <div
        class="vdr_shade"
        :class="[rect.options.leftType === '%' || rect.options.topType === '%' ? 'no-drag' : '']"
        v-if="
          !rect.active &&
          (ids.rect_id !== rect.rect_id || ids.container_id !== id) &&
          !$store.state.states.leftMenuDragStatus &&
          rect.shape !== 'cxPageLayoutComponent' &&
          !isBigScreenPreview() &&
          rect.shape !== 'cxTabs'
        "
      ></div>
      <component
        :zoom="zoom"
        :rect="rect"
        :active="rect.active && !isElementInLayout"
        :options="rect.options"
        :parentOptions="parentElement"
        :rectheight="Number(rect.height)"
        :myid="{ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId }"
        :class="[
          'rect',
          rect.options.animateSets && rect.options.animateSets.animateType !== 0 ? 'animate__animated' : '',
          rect.options.animateSets && rect.options.animateSets.executionAnimateClass
            ? rect.options.animateSets.animateClass
            : ''
        ]"
        :style="bigScreenAnimateStyle(rect.options)"
        :is="rect.shape === 'emptyLayoutComponent' ? 'layoutComponent' : rect.shape"
      ></component>
    </VueDragResizable>
    </template>
    <!--辅助线 -->
    <template>
      <span
        class="ref-line v-line"
        v-for="item in vLine"
        :key="'vLine_' + item.id"
        v-show="item.display"
        :style="{
          left: item.position,
          top: item.origin,
          height: item.lineLength
        }"
      />
      <span
        class="ref-line h-line"
        v-for="item in hLine"
        :key="'hLine_' + item.id"
        v-show="item.display"
        :style="{
          top: item.position,
          left: item.origin,
          width: item.lineLength
        }"
      />
    </template>
    <!--辅助线END-->
    <!--克隆遮罩-->
    <div @click.stop @mouseenter.stop v-if="!isActiveCell && !isOrderPattern" class="cell-clone-shade"></div>
  </div>
</template>

<script>
import VueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import {
  _throttle,
  encryption,
  handleFindLayoutComponentOptions,
  getAllElementsInColsInLayoutComponent,
  _debounce,
  smartMathMax
} from "utils/index"
import { getFirstModuleEncId, getSyetemModuleJson } from "@/utils/initEv.js"
import { data_dictionary_map } from "root/static/dataDictionary"
import componentMixIn from "./colsMixin"
import { deepChangeUid } from "utils"
import $ from "jquery"
import { CATEGORY_MODE } from "@/consts"

export default {
  name: "layout-cell",
  mixins: [componentMixIn],
  components: {
    VueDragResizable
  },
  props: {
    baseComponent: {
      type: Array
    },
    index: {
      type: Number
    },
    id: {
      type: Number,
      default: 0
    },
    parentElement: {
      type: Object
    },
    stageType: {
      type: String,
      default: undefined
    },
    isBigScreen: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      default: 1
    },
    isActive: {
      type: Boolean,
      default: false
    },
    contentWidth: {
      type: Number
    },
    children: { type: Array },
    appEditWidth: {
      type: Number
    },
    rect: {
      type: Array,
      required: true
    },
    curIndex: {
      type: [String, Number],
      required: true
    },
    layout: {
      type: Object,
      required: true
    },
    rect_id: {
      type: Number
    },
    options: {
      type: Object,
      default: null
    },
    isAccordionLayout: {
      type: Boolean,
      required: true
    },
    openIndex: {
      type: Number,
      required: true
    },
    isShowVerticalTabs: {
      type: [Boolean, String],
      default: false
    },
  },
  data() {
    return {
      resizeOb: null,
      isDragover: false,
      this2: this,
      dialogFormVisible3: false,
      saveModuleForm: {
        name: null,
        type: null
      },
      formLabelWidth: "120px",
      dialogFormVisible: false,
      dialogFormVisible2: false,
      cacheDataTypes: [],
      restDataUrl: null,
      typeVal: null,
      initContainerH: null,
      containerBtnLock: null,
      colsIdFromActiveRect: [],
      showModuleHandles: true,
      mounted: false,
      autoPlayAnimate: true,
      getParentW: null,
      getParentH: null,
      vLine: [],
      hLine: [],
      showEmptyTip: true,
      // getParentH:null
      dragging: false,
      insertIndex: null,
      activeIndex: -1, // 激活组件
    }
  },
  computed: {
    getVdrWrapStyle() {
      return function (rect) {
        return {
          position: "absolute",
          width: "100%",
          // height: this.baseComponent?.indexOf(rect.shape)>-1?"":"100%",
          height: "100%"
        }
      }
    },
    isPhoneFullScreen() {
      return this.$store.state[this.request_prefix].page.isPhoneFullScreen
    },
    // dataSource() {
    //   return this.$store.state[this.request_prefix].page.children[0].children
    // },
    ids() {
      return this.$store.state.states.activeID
    },
    isElementInLayout() {
      if (this.ids.uid) {
        return true
      }
      if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
        return true
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        return true
      }
      return false
      // 下面这种写法 ids变化的时候 不一定会重新计算
      // return this.ids.hasOwnProperty("elementInLayoutId") || this.ids.hasOwnProperty("uid") || (this.ids.hasOwnProperty("elementInSwiperId") && this.ids.elementInSwiperId != undefined)
    },
    cellRect: {
      get() {
        return this.rect
      },
      set(newVal) {
        this.$emit("update:rect", newVal)
      }
    },
    pageLayoutList: {
      get() {
        return this.$store.state[this.request_prefix].page.pageLayoutList
      }
    },
    renderCurrentTabData() {
      let pageLayout = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.id,
        rect_id: this.rect_id
      })
      return pageLayout.options?.renderCurrentTabData || false
    },
    // 在横行标签布局中，不在当前tab下的iframe和自由布局不显示，减少初始化的加载
    showComponent() {
      return function (rect) {
        const shape = ["cxIframe", "emptyLayoutComponent"]
        const {isShowTabs, activeIndex} = this.options
        if (isShowTabs && shape.includes(rect.shape)) {
          const curArr = this.curIndex?.split("_")
          const maxLength = this.isShowVerticalTabs ? 3 : 2
          const index = curArr?.length > maxLength ? curArr[maxLength + 1] : curArr[curArr.length - 1]
          return index == activeIndex
        } else return true
      }
    },
    pageType() {
      let type = this.$store.state[this.request_prefix].type
      if (type === "listPage" || type === "detailPage") {
        return type
      }
      let pageList = this.$store.state.states.pageList
      let { pageId } = this.$store.state.states.getDataPageIds
      let curPageObj = pageList.find(item => item.publicId === pageId)
      if (curPageObj && curPageObj.isHomePage !== 1 && type !== "equalPage") {
        type = "equalPage"
      }
      return type
    },
    isActiveCell() {
      if (this.ids.rect_id === null || typeof this.ids.rect_id === "undefined") {
        return false
      }
      if (this.cellRect.length > 0 && this.cellRect.includes(this.ids.rect_id)) {
        return !this.forbidActive
      }
      return false
    },
    cellData() {
      let data = []
      let dataSource = this.$store.state[this.request_prefix].page.children[0].children
      this.cellRect.forEach(item => {
        for (let i = 0; i < dataSource.length; i++) {
          if (item == dataSource[i].rect_id) {
            data.push(dataSource[i])
            break
          }
        }
      })
      return [...new Set(data)]
    },
    layoutSize() {
      // 一帆提的 移动端宽度小于20% 高度小于40px不显示提示文字
      if (this.request_prefix === "appStage") {
        let layout = this.layout?.options
        if (parseInt(layout?.height) < 40 || parseInt(layout?.width) < 20) return false
      }
      return true
    },
    zIndexControl() {
      if (this.$store.state[this.request_prefix].page.stageType == "layOut") {
        return { zIndex: "2" }
      } else if (this.isPhoneFullScreen) {
        return {}
      }
    },
    getSpecialStyle() {
      return function (rect) {
        // 自动布局内部为定位,所以padding需要放在外层
        // if (rect.shape === "cxAutoLayout") {
        //   let borderW = ""
        //   if (Array.isArray(rect.options.borderWidth)) {
        //     rect.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        //   } else {
        //     borderW += ` ${rect.options.borderWidth}px`
        //   }

        //   let padding = `${rect.options.padding}px`
        //   let boxShadow = `0 0 0 ${padding}   rgba(56, 154, 30, 0.4)  inset`
        //   if (!rect.options.textPaddingTypeFlag || rect.options.textPaddingTypeFlag === 2) {
        //     padding = ` ${rect.options.paddingTop}px  ${rect.options.paddingRight}px  ${rect.options.paddingBottom}px  ${rect.options.paddingLeft}px`
        //     boxShadow = `0 -${rect.options.paddingBottom}px 0 0   rgba(56, 154, 30, 0.4)  inset, -${rect.options.paddingRight}px 0 0 0    rgba(56, 154, 30, 0.4)   inset , ${rect.options.paddingLeft}px 0 0 0  rgba(56, 154, 30, 0.4)  inset, 0 ${rect.options.paddingTop}px 0 0   rgba(56, 154, 30, 0.4)  inset`
        //   }
        //   let margin = `${rect.options.margin}px`
        //   if (rect.options.marginTypeFlag === 2) {
        //     margin = ` ${rect.options.marginTop}px ${rect.options.marginRight}px ${rect.options.marginBottom}px ${rect.options.marginLeft}px`
        //   }
        //   return {
        //     // padding: padding,
        //     // boxShadow: rect.active ? boxShadow : undefined,
        //     // "border-top-left-radius": rect.options.borderTopLeftRadius + "px",
        //     // "border-top-right-radius": rect.options.borderTopRightRadius + "px",
        //     // "border-bottom-right-radius": rect.options.borderBottomRightRadius + "px",
        //     // "border-bottom-left-radius": rect.options.borderBottomLeftRadius + "px",
        //     // "border-style": rect.options.borderStyle,
        //     // "border-color": rect.options.borderIsThemeColor
        //     //   ? this.themeColor
        //     //   : rect.options.borderColor.color
        //     //   ? rect.options.borderColor.color
        //     //   : rect.options.borderColor,
        //     // "border-width": borderW
        //     margin: margin
        //   }
        // }
      }
    },
    getAutoLayoutContentStyle() {
      return function(type) {
        if (!type && this.isAccordionLayout) return {}
      let options = this.layout?.options
      if (!options?.showRowColLayout) return {}
      let alignItems = "start"
      let justifyContent = "start"
      let alignContent = "start"
      switch (options.rowColAlignPositionH) {
        case "left":
          alignItems = "start"
          break
        case "center":
          alignItems = "center"
          break
        case "right":
          alignItems = "end"
          break
      }
      switch (options.rowColAlignPositionV) {
        case "top":
          justifyContent = "start"
          break
        case "middle":
          justifyContent = "center"
          break
        case "bottom":
          justifyContent = "end"
          break
      }
      if (options.rowColDirection === "horizon") {
        alignContent = justifyContent
      } else {
        alignContent = alignItems
      }
      let marginBottom = "" //行布局为下边距 列布局为右边距
      let marginRight = "" //行布局为右边距 列布局为下边距
      let rowGap = ""
      let columnGap = ""
      if (options.showRowColLayout) {
        // 开启自动行列布局
        marginBottom = options.marginType !== 'auto' ? options.rowColMargin + "px" : ""
        if (options.autoWrap) {// 开启自动换行
          marginRight = options.rowColMarginRight + "px"
        }
      }
      if (options.rowColDirection === 'horizon') {
        columnGap = options.marginType !== 'auto' ? marginBottom : ""
        rowGap = marginRight
      } else {
        rowGap = options.marginType !== 'auto' ? marginBottom : ""
        columnGap = marginRight
      }
      return {
        display: "flex",
        "align-content": options.autoWrap ? alignContent : "", //换行后显示格式
        "flex-direction": options.rowColDirection === "horizon" ? "row" : "column",
        "flex-wrap": options.autoWrap ? "wrap" : "nowrap",// 是否换行
        "align-items": options.rowColDirection === "horizon" ? justifyContent : alignItems,// 水平对齐格式
        "justify-content": options.marginType === "auto" ? "space-between" : options.rowColDirection === "horizon" ? alignItems : justifyContent, // 垂直对齐格式
        "row-gap": rowGap, // 行间距
        "column-gap": columnGap, // 列间距
        // 取间距的一半，但是视觉上不在中间，所以+1
        "--custom-margin": options.marginType !== 'auto' && options.rowColMargin
            ? -(options.rowColMargin / 2 + 1) + "px"
            : 0,
      }
      }
    },
    // 溢出判断显示隐藏滚动
    getOverStyle() {
      let style = {}
      let overflow = "visible"
      let options = this.layout?.options
      // if (!options?.showRowColLayout) return {}
      if (options.overFlowType == "scroll") {
        overflow = "scroll"
      } else if (options.overFlowType) {
        overflow = options.overFlowType
      }
      let rowColDirection = options.rowColDirection
      if (rowColDirection === "horizon") {
        if (!options.autoWrap) {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        }

      } else {
        if (!options.autoWrap) {
          style = {
            "overflow-y": overflow ? overflow : "hidden",
            "overflow-x": overflow === "visible" ? "unset" : "hidden"
          }
        } else {
          style = {
            "overflow-x": overflow ? overflow : "hidden",
            "overflow-y": overflow === "visible" ? "unset" : "hidden"
          }
        }

      }
      return style
    },
    bgStyle() {
      if (!this.containerOptions) {
        return {}
      }
      let containerBg = {
        backgroundImage: "",
        height: this.stageHeight
      }
      let containerOptions = JSON.parse(JSON.stringify(this.containerOptions))
      if (!containerOptions.background || !Array.isArray(containerOptions.background)) {
        let defalutColor = this.request_prefix === "stage" ? "#fff" : "#00043A"
        containerOptions.background = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: containerOptions.bgColor || defalutColor
          }
        ]
      }
      containerOptions.background.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},${bg.clipSize}`:`${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},${bg.alignType}`:`${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},${bg.repeatType}`:`${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                tmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              bg.data.stops.forEach(item => {
                radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage +=
                dot + this.$parseColor(bg)
              containerBg.backgroundSize =containerBg.backgroundSize?`${containerBg.backgroundSize},auto`:`auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition?`${containerBg.backgroundPosition},center`:`center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat?`${containerBg.backgroundRepeat},no-repeat`:`no-repeat`
            }
            break
          default:
        }
      })
      return { ...containerBg, ...this.styleObject }
    },
    styleObject() {
      if (!this.containerOptions) {
        return {}
      }
      if (this.request_prefix === "bigScreen") {
        return {}
      }
      let fixStyle = {
        opacity: this.containerOptions.opacity / 100,
        width: "100%",
        height: "100%"
      }
      return fixStyle
    },
    bigScreenAnimateStyle() {
      return function (options) {
        if (this.request_prefix === "bigScreen" || !options.animateSets) {
          return {}
        }
        return {
          // "animation-delay": options.animateSets.animateDelay * 1000 + "ms",
          // "animation-duration": options.animateSets.animateDuration * 1000 + "ms"
        }
      }
    },
    judgeIsFullRect() {
      return function (rect) {
        return this.baseComponent?.indexOf(rect.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          // 自动布局下的组件不需要充满 可自定义尺寸
          rect.options?.pluginName?.indexOf("ListPageSearchComponentPlugin") > -1 || this.layout?.options?.showRowColLayout || this.layout?.options?.showMultipleLayout
          ? ""
          : "is_full_rect"
      }
    },
    getDraggable() {
      return function (rect) {
        if (this.forbidActive) {
          return false
        }
        return this.baseComponent?.indexOf(rect.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          rect.options?.pluginName?.indexOf("ListPageSearchComponentPlugin") > -1 ||
          // 自动布局中，所有组件都当做基础组件处理
          this.layout?.options?.showRowColLayout ||
          this.layout?.options?.showMultipleLayout
          ? rect.draggable
          : false
      }
    },
    // getParentH() {
    //   let height = this.layout.options.height
    //   if (this.layout.options.heightType === "自动") {
    //     height = this.layout.options.boundHeight
    //   }
    //   console.log("height",height - this.layout.options.padding[0] - this.layout.options.padding[2])
    //   return height - this.layout.options.padding[0] - this.layout.options.padding[2]
    // },
    // 判断是否禁止编辑
    forbidActive() {
      if (this.pageType !== "listPage" && this.pageType !== "detailPage" && this.pageType !== "equalPage") {
        return false
      }
      let inHead = false
      let targetLayout = null
      const travel = arr => {
        arr.forEach(item => {
          const layout = item.layout
          if (layout) {
            if (item === this.layout) {
              inHead = true
            }
            if (layout.rows && layout.rows.length > 0) {
              travel(layout.rows)
            }
            if (layout.cols && layout.cols.length > 0) {
              travel(layout.cols)
            }
          }
        })
      }
      for (let i = 0; i < this.pageLayoutList.length; i++) {
        if (["header", "footer"].includes(this.pageLayoutList[i].options.inDocument)) {
          travel([this.pageLayoutList[i]])
          if (inHead) {
            targetLayout = this.pageLayoutList[i]
            break
          }
        }
      }
      if (targetLayout) {
        const isRefHome = targetLayout.options.isRefHome
        return typeof isRefHome === "undefined" ? (this.pageType === "equalPage" ? false : true) : isRefHome
      } else {
        return false
      }
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(val) {
        this.$store.commit("states/changeShowRightToolbarStatus", val)
      }
    },
    isOrderPattern() {
      return this.$store.state.states.isOrderPattern
    }
  },
  mounted() {
    // this.watchResize()
    this.$nextTick(()=>{
      this.getParentW = Number(window.getComputedStyle(this.$el).getPropertyValue("width").slice(0, -2))
      this.getParentH = Number(window.getComputedStyle(this.$el).getPropertyValue("height").slice(0, -2))
    })
  },
  beforeDestroy() {
    this.resizeOb && this.resizeOb.unobserve(this.$el)
  },
  methods: {
    watchResize(maxTask = 0) {
      if (this.request_prefix === "appStage") return
      if (this.$el) {
        this.resizeOb = new ResizeObserver(
          _debounce(el => {
            let boundWidth, boundHeight
            if (el[0]?.contentRect?.width) {
              boundWidth = el[0].contentRect.width
              boundHeight = el[0].contentRect.height
              this.$changeOptionsEV(boundWidth, "boundWidth", null, false, {
                pageLayoutId: this.curIndex
              })
              this.$changeOptionsEV(boundHeight, "boundHeight", null, false, {
                pageLayoutId: this.curIndex
              })
              let pageLayout = this.getAttrById.call(
                this,
                this.$store.state[this.request_prefix],
                {
                  container_id: this.ids.container_id,
                  rect_id:this.ids.rect_id,
                  pageLayoutId: this.curIndex
                },
                "pageLayout"
              )
              if (pageLayout?.options?.showRowColLayout && pageLayout?.options?.heightType === "自动") {
                // 如果当前布局是自动布局 需要修改父级通栏的高度
                let ids = this.curIndex.split("_")
                ids.splice(ids.length - 1, 1)
                let newPageLayoutId = ids.join("_")
                this.$changeOptionsEV(boundHeight, "height", false, "", {
                  pageLayoutId: newPageLayoutId
                }, true)
              }
              if ((boundWidth <= 100 && boundHeight <= 40) || boundWidth <= 50 || boundHeight <= 20) {
                this.showEmptyTip = false
              } else {
                this.showEmptyTip = true
              }
            }
          }, 200)
        )
        this.resizeOb.observe(this.$el)
        const boundingSize = this.$el.getBoundingClientRect()
        this.$changeOptionsEV(boundingSize.width, "boundWidth", null, false, { pageLayoutId: this.curIndex })
        this.$changeOptionsEV(boundingSize.height, "boundHeight", null, false, { pageLayoutId: this.curIndex })
      } else if (maxTask < 10) {
        requestAnimationFrame(() => this.watchResize(maxTask + 1))
      } else {
        throw new Error("maxTask超出最大深度")
      }
    },
    clickLayoutCol(e) {
      if (this.forbidActive) {
        return
      }
      //  取消自动布局内元素选中状态
      const activeIds = JSON.parse(JSON.stringify(this.ids))
      if (activeIds.hasOwnProperty("elementInAutoLayoutId")) {
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", activeIds)
      }
      // 关闭右键菜单
      this.$store.commit("states/changeRightBtnStatu", false)
      if (this.isBigScreenPreview()) return
      this.$store.commit("states/changeActiveID", { container_id: this.ids.container_id,rect_id: this.ids.rect_id, pageLayoutId: this.curIndex })
      this.$store.commit("states/changeElementType", "cxPageLayoutComponentCell")
      sessionStorage.setItem("mouseX", e.offsetX)
      sessionStorage.setItem("mouseY", e.offsetY)
      this.$emit("activeLayoutCell", e)

      this.showRightToolbar = true
    },
    dragoverEv(e) {
      sessionStorage.setItem("dropOverCell", true)
      sessionStorage.setItem("dropOverCellComponent", true)
      // e.dataTransfer.dropEffect="link"
      let rectShape = localStorage.getItem("dragType")
      sessionStorage.setItem("dropOverCellComponentShape", rectShape)
      if (rectShape !== "cxPageLayout") {
        e.dataTransfer.dropEffect = "copy"
        this.isDragover = true
      } else {
        e.dataTransfer.dropEffect = "none"
      }
    },
    dragoverLeaveEv(e) {
      console.log("dragoverLeaveEv")
      sessionStorage.removeItem("dropOverCell")
      sessionStorage.removeItem("dropOverCellComponent")
      this.isDragover = false
    },
    checkAndSetVal(opt, key, optname, val, ids) {
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, ids)
        return val
      } else {
        return opt[key]
      }
    },
    // 处理自动布局组件设置尺寸为% 或者auto时候的手柄情况
    checkResizable(rect) {
      if (this.layout?.options?.showRowColLayout || rect.shape === "cxAutoLayout") {// 自动布局中
        return true
      }
      if (this.judgeIsFullRect(rect)) {
        return false
      }
      let widthType = rect.options.hasOwnProperty("widthType") ? rect.options.widthType : "px"
      let heightType = rect.options.hasOwnProperty("heightType") ? rect.options.heightType : "px"
      if (widthType !== "px" && heightType !== "px") {
        return false
      }
      return rect.resizable
    },
    checkHandles(rect) {
      if (!rect.resizable) {
        return []
      }
      let widthType = rect.options.hasOwnProperty("widthType") ? rect.options.widthType : "px"
      let heightType = rect.options.hasOwnProperty("heightType") ? rect.options.heightType : "px"
      if (this.layout?.options?.showRowColLayout || rect.shape === "cxAutoLayout") {
        return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
      }
      if (widthType !== "px" && heightType !== "px") {
        return []
      }
      if (widthType === "px" && heightType !== "px") {
        return ["ml", "mr"]
      }
      if (widthType !== "px" && heightType === "px") {
        return ["tm", "bm"]
      }
      return ["tl", "tm", "tr", "mr", "br", "bm", "bl", "ml"]
    },
    clickVdr() {
      // this.$emit("clickVdr");
    },
    checkExcute() {
      const ids = this.ids
      this.$confirm("确认重新绘制吗？", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认重新绘制吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          this.fixActiveId(ids)
          this.handleReRender()
        })
        .catch(err => {
          this.fixActiveId(ids)
          console.log(err)
        })
    },
    fixActiveId(ids) {
      const delActive = {
        container_id: ids.container_id,
        rect_id: ids.rect_id,
        uid: ids.uid,
        elementInLayoutId: ids.elementInLayoutId,
        option_name: "isActive",
        option_val: "delAllActive"
      }
      Object.keys(delActive).every(k => delActive[k]) &&
        this.$store.dispatch(this.request_prefix + "/changeLayoutActive", delActive)
      this.$store.commit("states/changeActiveID", { container_id: ids.container_id, rect_id: ids.rect_id })
      this.$store.dispatch(this.request_prefix + "/setActive", { container_id: ids.container_id, rect_id: ids.rect_id })
    },
    //重新绘制布局组件并把数据取出来
    handleReRender() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
      const pOptions = [rectAttr.options.rows[useActiveIndex]]
      const colsElementOptions = []
      this.getAllUidInLayoutComponent(pOptions).forEach(uid => {
        colsElementOptions.push(handleFindLayoutComponentOptions(pOptions, uid))
      })
      this.$emit("reRender", colsElementOptions)
    },
    compress(base64String, w, quality) {
      var getMimeType = function (urlData) {
        var arr = urlData.split(",")
        var mime = arr[0].match(/:(.*?);/)[1]
        // return mime.replace("image/", "");
        return mime
      }
      var newImage = new Image()
      var imgWidth, imgHeight

      var promise = new Promise(resolve => (newImage.onload = resolve))
      newImage.src = base64String
      return promise.then(() => {
        imgWidth = newImage.width
        imgHeight = newImage.height
        var canvas = document.createElement("canvas")
        var ctx = canvas.getContext("2d")
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w
            canvas.height = (w * imgHeight) / imgWidth
          } else {
            canvas.height = w
            canvas.width = (w * imgWidth) / imgHeight
          }
        } else {
          canvas.width = imgWidth
          canvas.height = imgHeight
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.drawImage(newImage, 0, 0, canvas.width, canvas.height)
        var base64 = canvas.toDataURL(getMimeType(base64String), quality)
        return base64
      })
    },
    moduleHandlesStatuChange($event) {
      this.showModuleHandles = !$event
    },

    initDataPageIds(newParam) {
      const dataPageIds = this.$store.state.states.getDataPageIds
      console.log("getDataPageIds", dataPageIds)
      const param = { ...dataPageIds, ...newParam }
      if (!!newParam) {
        Object.keys(newParam).forEach(key => (param[key] === newParam[key] ? "" : param[key] === newParam[key]))
        this.$store.commit("states/updateDataPageIds", param)
      }
      return param
    },
    bindDataEv() {
      this.dialogFormVisible = true
    },
    handleParam() {
      const ids = this.ids
      let content = JSON.parse(JSON.stringify(this.getRectAttribute.call(this, ids)))
      content.active = false
      content = encryption(content, data_dictionary_map)
      const param = {
        c: content,
        a: "7C5C8F204A2F4171"
      }
      return param
    },
    openSaveModuleDialog() {
      this.dialogFormVisible3 = !this.dialogFormVisible3
    },
    changeHeightMouseDownEv(ev) {
      this.initContainerH = ev.screenY
    },
    handdleClearActive() {
      this.clearActiveInLayoutComponentWithAlignHelper() //处理手动辅助对齐的时候的acitve
      this.clearAutoLayoutElementActive()
      this.clearSwiperElementActive() //处理轮播组件内组件的active
      this.hanleLayoutBacgroundColorClear() //处理布局组件背景色的active
      this.handleClearLeftMenuActive() //处理leftmenu的active
      if (this.$store.state.states.toolBarStatus) this.$store.commit("states/changeToolBarStatus", false)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
      this.checkContainerActiveID() //处理ids，一定要放在最后！！！
    },
    handleClearLeftMenuActive() {
      const acId = this.$store.getters["menu/getActiveMenu"]
      if (acId) this.$store.dispatch("menu/unsetActive", { id: acId })
      if (this.$store.state.states.showLeftMenu) {
        this.$store.commit("states/changeShowLeftMenuStatus", false)
      }
    },
    checkContainerActiveID() {
      if (
        this.ids &&
        (this.ids.container_id !== this.id ||
          Object.keys(this.ids).some(k => k != "container_id" && this.ids[k] !== null))
      ) {
        this.$store.commit("states/changeActiveID", { container_id: this.id })
      }
    },
    clearSwiperElementActive() {
      const clearActive = {
        ...this.ids
      }
      for (const k in clearActive) {
        if (clearActive[k] === null) delete clearActive[k]
      }
      if (clearActive.hasOwnProperty("elementInSwiperId") && clearActive.elementInSwiperId !== null) {
        clearActive.elementInSwiperId = null
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    clearAutoLayoutElementActive(elementOptions) {
      let container = this.$store.state[this.request_prefix].page.children.find(
        children => children.container_id === this.id
      )
      let rect = container.children.find(rect => rect.rect_id === this.ids.rect_id)
      let rectElement = rect && rect.options ? (rect.options.elementOptions ? rect.options.elementOptions : []) : []
      elementOptions = elementOptions || rectElement
      elementOptions.forEach(item => {
        let param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: item.elementInAutoLayoutId,
          path: item.path
        }
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", param)
        if (item.elementOptions && item.elementOptions.length > 0) {
          this.clearAutoLayoutElementActive(item.elementOptions)
        }
      })
    },
    hanleLayoutBacgroundColorClear() {
      if (JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing") {
        let param = { ...JSON.parse(window.localStorage.getItem("oldActiveData")) }
        param.option_val = "delAllActive"
        if (Object.keys(param).length === 3) {
          this.$store.dispatch(this.request_prefix + "/unsetActive", {
            container_id: param.container_id,
            rect_id: param.rect_id
          })
        }
        const clearElementInLayoutStatus =
          param.uid !== null &&
          param.elementInLayoutId !== null &&
          param.hasOwnProperty("uid") &&
          param.hasOwnProperty("uid")
        if (clearElementInLayoutStatus) {
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
        window.localStorage.setItem("oldActiveData", JSON.stringify("nothing"))
      }
      let elementType = this.request_prefix === "bigScreen" ? "bigScreenContainer" : "container"
      this.$store.commit("states/changeElementType", elementType)
      if (this.$store.state.states.alignHelperStatus) this.$store.commit("states/changeAlignHelperStatus", false)
    },
    clickContainer: _throttle(function (e) {
      if (this.isBigScreenPreview()) return
      this.$emit("clickContainer", e)
      const acId = this.$store.getters["menu/getActiveMenu"]
      // 选中当前容器
      const _stage = this.$store.state[this.request_prefix]
      if (!this.getAttrById(_stage, { container_id: this.id })?.isActive)
        this.$store.commit("states/changeActiveID", { container_id: this.id })
      this.$store.dispatch(this.request_prefix + "/setContainerActive", { container_id: this.id })
      this.$store.commit(
        "states/changeElementType",
        this.request_prefix.includes("bigScreen") ? "bigScreenContainer" : "container"
      )
      // 点击空白去掉逻辑文本的激活变量id
      this.$store.commit("states/changeLogicTextDynamicId", "")
      this.handdleClearActive()
    }, 100),
    contextmenuHandle(e) {
      if (e.button === 2) {
        this.$emit("contextmenu", e)
      }
    },
    resetRectAttrOpt(childItem, _attribute) {
      this.needHid = true
      let layoutUidMap = {}
      childItem.encId ? (_attribute.moduleId = childItem.encId) : ""
      childItem.typeId ? (_attribute.typeId = childItem.typeId) : ""
      // this.doAdd = true
      //鼠标移动处理
      if (this.request_prefix === "appStage" && _attribute.options.width > 414) {
        _attribute.options.width = 414
      }
      if (_attribute.shape === "layoutComponent" || "emptyLayoutComponent") {
        //递归修改uid 把menu里的默认uid（会导致cols的id值重复）修改为随机生成的uid
        layoutUidMap = deepChangeUid(_attribute)
      }
      _attribute.options.layoutUidMap = layoutUidMap
      return JSON.stringify(_attribute)
    },
    async drop2(e) {
      sessionStorage.removeItem("dropOverCell")
      sessionStorage.removeItem("isDragging")
      sessionStorage.removeItem('dropOverCellComponent')
      this.isDragover = false
      this.dragging = false
      this.insertIndex = null
      if (this.isBigScreenPreview()) return
      let dragType = localStorage.getItem("dragType")
      const loadingType = ['cxGaphic','cxSystemText','cxSystemSearch','swiperComponent']
      if(loadingType.indexOf(dragType)>-1){
        // 添加loading效果
        sessionStorage.setItem("isAddNewRect",true)
        // this.$el.classList.add("loading-newRect")
        this.$el.getElementsByClassName("loading-wrap")[0]?.classList.add("loading-newRect")
        // this.$el?.setAttribute("isLoading",true)
      }
      if (e.target.parentNode.classList[0] !== "componentBox_after") {
        let rectAttr = e.dataTransfer.getData("rectAttribute")
        let childItemInfo = sessionStorage.getItem("childItemInfo")
        childItemInfo = JSON.parse(childItemInfo)
        if (childItemInfo.childItemName === "收藏") {
          rectAttr = JSON.parse(rectAttr)
          const _attribute = await getSyetemModuleJson(rectAttr.encId)
          rectAttr = JSON.stringify(_attribute)
        } else if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined" || !JSON.parse(rectAttr).shape) {
          if (childItemInfo.childItemTypeId) {
            let childItem = await getFirstModuleEncId.call(this, childItemInfo.childItemTypeId)
            let type = childItem.content.shape
            let attribute = childItem.content
            const _attribute = JSON.parse(JSON.stringify(attribute))
            rectAttr = this.resetRectAttrOpt(childItem, _attribute)
          } else {
            return
          }
        }
        rectAttr = JSON.parse(rectAttr)

        if (childItemInfo && childItemInfo.childItemTypeId) {
          rectAttr.options.componentTypeId = childItemInfo.childItemTypeId
          rectAttr.options.name = childItemInfo.childItemTitle ? childItemInfo.childItemTitle : childItemInfo.childItemName
          rectAttr.options.componentTypeName = childItemInfo.childItemTypeName
        }
        this.getParentH = Number(window.getComputedStyle(this.$el).getPropertyValue("height").slice(0, -2))
        if (this.isAccordionLayout) {// 手风琴布局内组件的状态
          if (this.openIndex === this.index) rectAttr.options.isOpenState = true
          else if (rectAttr.options.hasOwnProperty("isOpenState")) rectAttr.options.isOpenState = false
        }
        this.addNewRect(
          {
            rectAttr: rectAttr,
            cellRect: this.cellRect,
            type: "new",
            isClone: false
          },
          e
        )
      }
    },
    // 新加入rect
    addNewRect(param, e) {
      let rectAttr = JSON.parse(JSON.stringify(param.rectAttr))
      deepChangeUid(rectAttr)
      let cellRect = param.cellRect
      let newIndex = param.index
      // 单元格里不能放布局通栏
      if (param.type === "new") {
        if (rectAttr.shape === "cxPageLayout" || rectAttr.shape === "cxPageLayoutComponent") {
          return
        }
        if (
          this.baseComponent.indexOf(rectAttr.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          (rectAttr.options.pluginName && rectAttr.options.pluginName.indexOf("ListPageSearchComponentPlugin") > -1) || this.layout?.options?.showRowColLayout ||
          this.layout?.options?.showMultipleLayout
        ) {
          // 基础元素，支持在col内自由拖拽
          const [top, left] = this.getOffsetPosition(e)
          let optionsTop = (top - (rectAttr.options.height / 2) * this.zoom) / this.zoom
          let optionsLeft = (left - (rectAttr.options.width / 2) * this.zoom) / this.zoom
          rectAttr.options.top = optionsTop < 0 ? 0 : optionsTop
          rectAttr.options.left = optionsLeft < 0 ? 0 : optionsLeft
          // 新增的充满组件默认zIndex是2,如果有修改，需要同步waterFall中的newRectIndex
          rectAttr.options.zIndex = 2

          let maxHeight = rectAttr.options.top + rectAttr.options.height
          if (this.$el.getElementsByClassName("is_full_rect").length === 0 && maxHeight > this.layout.options.height) {
            this.$emit("changeCellSize", undefined, maxHeight)
          } else if (maxHeight > this.getParentH) {
            // 缩小当前元素 最小高度20px
            let lastHeight = this.getParentH - rectAttr.options.top
            rectAttr.options.height = lastHeight < 20 ? 20 : lastHeight
          }
          if (rectAttr.options?.innerElement === "emptyLayoutComponent" && (this.layout?.options?.showRowColLayout || this.layout?.options?.showMultipleLayout)) {
            rectAttr.options.width = 600
            rectAttr.options.widthType = "px"
            rectAttr.options.height = 500
            rectAttr.options.heightType = "px"
          }
        } else {
          let isFullRect = this.$el.getElementsByClassName("is_full_rect")
          if (this.isAccordionLayout) {
            isFullRect = this.cellData?.length > 0 ? this.$el.querySelectorAll(".accordionContent:not(.hidden)")[0]?.getElementsByClassName("is_full_rect") : []
          }
          if (isFullRect?.length === 0) {
            // if(rectAttr.shape === "emptyLayoutComponent" || rectAttr.shape === "layoutComponent"){

            // 如果当前布局开启了自动占满屏幕高度，则不再去改布局高度，保存高度为屏幕高度
            !this.layout.options.isFullHeight && this.$emit("changeCellSize", undefined, rectAttr.options.height)
            // this.$emit("changeCellSize", undefined, rectAttr.options.height)
            // }else{
            //   this.$emit("changeCellSize",rectAttr.options.width,rectAttr.options.height)
            // }
            // 一个col里面只能放一个组件（非基础元素）
            rectAttr.options.top = 0
            rectAttr.options.left = 0
            rectAttr.options.width = 100
            rectAttr.options.widthType = "%"
            rectAttr.options.height = 100
            rectAttr.options.heightType = "%"
            rectAttr.options.zIndex = 1
            rectAttr.options.draggable = false
            rectAttr.options.resizable = false
            // 提高当前布局/栅格内的其他基础组件的层级 -- 一帆需求
            this.cellData.forEach(rect => {
              if (rect.options.zIndex <= rectAttr.options.zIndex) {
                this.$changeOptionsEV(rectAttr.options.zIndex + rect.options.zIndex +1, "zIndex", false, false, {
                  container_id: this.id,
                  rect_id: rect.rect_id
                }, true)
              }
            })
          } else {
            let classList = document.getElementsByClassName("loading-newRect")[0]?.classList
            if(classList){
              let loadingRect = document.getElementsByClassName("loading-newRect")
              loadingRect.length === 1 && sessionStorage.removeItem("isAddNewRect")
              classList.remove("loading-newRect")
            }
            console.log("一个col里面只能放一个组件")
            return
          }
        }
      }
      const allRects = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
        container_id: this.id
      }).children
      // let _rect_id = allRects.length ? allRects[allRects.length - 1].rect_id : -1
      let _rect_id = -1
      if (allRects.length > 0) {
        _rect_id = smartMathMax(
          ...allRects.map(function (o) {
            return o.rect_id
          })
        )
      }
      let rect_id = _rect_id + 1
      if (typeof newIndex !== "undefined") {
        cellRect.splice(newIndex, 1, rect_id)
      } else {
        cellRect.push(rect_id)
      }
      // 如果当前数据中存在appId判断当前组件是否是系统保存好的样式
      if (rectAttr.options.myFetchParam?.appId || rectAttr.options.appId) {
        //更新appid
        const appId = rectAttr.options.myFetchParam?.appId
          ? rectAttr.options.myFetchParam?.appId
          : rectAttr.options.appId
        // 需要判断当前组件类型，如果是基于自由布局开发的搜索组件/导航菜单，需要特殊处理
        const isSearchComponent = rectAttr.options.pluginName?.includes("searchComponentPlugin")
        const isNavComponent = rectAttr.shape.toLowerCase().includes("nav")
        this.$styleToSaveModule("31CB73E03E24BBFF", "临时", appId, param.isClone, isSearchComponent, isNavComponent)
          .then(res => {
            if (!!res.appId) {
              // 没有myfetchparam的组件 比如搜索组件 更新appId
              rectAttr.options.appId = res.appId
              if (rectAttr?.options?.myFetchParam) {
                //如果拖入画布的组件有，myfetchparam，证明是自由布局或者轮播
                //则pageId,wfwfid,websiteId,更新为当前页面的值，防止老组件id不兼容
                const { pageId, wfwfid, websiteId } = this.$store.state.states.getDataPageIds
                rectAttr.options.appId = res.appId
                rectAttr.options.moduleId = res.moduleId
                rectAttr.options.myFetchParam.pageId = pageId
                rectAttr.options.myFetchParam.wfwfid = wfwfid
                rectAttr.options.myFetchParam.websiteId = websiteId
                rectAttr.options.myFetchParam.appId = res.appId
              }
              // 克隆的组件需要将原组件的子页面相关id清空
              if (param.isClone) {
                delete rectAttr.options.detailPageId
                delete rectAttr.options.detailPageTemplateEncId
                delete rectAttr.options.listPageId
                delete rectAttr.options.listPageTemplateEncId
              }
              const params = {
                containerID: this.id,
                data: rectAttr
              }
              this.$store.dispatch(this.request_prefix + "/addElement", params)
              if (!param.isClone) {
                // 如果是复制布局，则不激活组件
                this.activateEv(this.id, rect_id, rectAttr.shape)
              }
            }
          })
          .catch(err => console.log(err))
      } else {
        const params = {
          containerID: this.id,
          data: rectAttr
        }
        this.$store.dispatch(this.request_prefix + "/addElement", params)
        if (!param.isClone) {
          // 如果是复制布局，则不激活组件
          this.activateEv(this.id, rect_id, rectAttr.shape)
        }
      }
      const lowerShape = rectAttr.shape.toLowerCase()
      //如果是自由布局组件 那就要检测自由布局组件内的组件是否有appid
      if (lowerShape.includes("layout")) {
        const allElementInLayout = getAllElementsInColsInLayoutComponent(rectAttr.options.rows)
        for (let uid in allElementInLayout) {
          const col = allElementInLayout[uid]
          col.elementInLayout &&
            col.elementInLayout.forEach(elementInLayout => {
              if (elementInLayout.appId) {
                const { elementInLayoutId } = elementInLayout
                this.$saveModule(
                  { container_id: this.ids.container_id, rect_id: rectAttr.rect_id, uid, elementInLayoutId },
                  "31CB73E03E24BBFF",
                  "临时",
                  false,
                  elementInLayout.appId
                )
              }
            })
        }
      }
    },
    getOffsetPosition(e) {
      let top = Number(e.offsetY) * this.zoom
      let left = Number(e.offsetX) * this.zoom
      console.log(top)
      const path = [e.target]
      this.getParentNode(e.target, path)
      path.some(el => {
        let classList = el.classList
        if (classList) {
          if (classList[0] === "myContainer") {
            return true
          } else if ([].find.call(classList, it => it === "vdr")) {
            const position = window.getComputedStyle(el).getPropertyValue("transform")
            top += Number(position.split(",")[position.split(",").length - 1].slice(0, -1)) * this.zoom
            left += Number(position.split(",")[position.split(",").length - 2]) * this.zoom
          }
        }
      })
      console.log(top)
      return [top, left]
    },
    getParentNode(e, res = []) {
      const parentNode = e.parentNode
      if (parentNode) {
        res.push(parentNode)
        this.getParentNode(parentNode, res)
      } else {
        return res
      }
    },
    dragoverEV(e) {},
    //删除element
    delElementEv(args) {
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          //执行删除操作
          //获取所有键
          const keys = Object.keys(args)
          const ableIn = keys.every(item => {
            return item !== null
          })

          //判断是否每个键值都不为null
          if (keys.length === 2 && ableIn) {
            this.$store.commit("states/changeElementType", null)
            this.$store.commit("states/changeActiveID", { container_id: this.ids.container_id })
            this.$store.dispatch(this.request_prefix + "/deleteElement", args)
          }
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {
          // this.$message({
          //   customClass: "bigScreen_msg_backGroud",
          //   duration: 3000,
          //   type: "error",
          //   message: "已取消删除"
          // })
        })
    },
    activateEv(id, index, shape, active) {
      if (this.forbidActive) {
        return
      }
      this.activeIndex = active
      // isShade 是判断是否是上层的遮罩
      // 控制缓存组件的appid同步
      this.clearSwiperElementActive()
      this.clearAutoLayoutElementActive()
      //取消title内选中态
      if (this.ids.directionIndex !== undefined) {
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", this.ids)
      }
      const myAttr = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
      const myAppId = myAttr.appId

      if (myAppId) {
        const { moduleId, typeId } = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
        this.initDataPageIds({ moduleId, typeId, appId: myAppId.appId })
      }

      if (JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing") {
        const param = JSON.parse(window.localStorage.getItem("oldActiveData"))
        if (param && (param.container_id !== id || param.rect_id !== index) && param.uid) {
          param.option_name = "isActive"
          param.option_val = false
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
      }
      if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: id,
          rect_id: index
        })
        // 选中自由布局时清除掉自由布局内元素的选中状态
        if (myAttr?.shape === "emptyLayoutComponent" || myAttr?.shape === "cxAutoLayout") {
          let param = {
            ...this.ids,
            option_name: "isActive",
            option_val: "delAllActive"
          }
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
        //    }
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: id,
          rect_id: index
        })
        let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        if (localStorage.getItem("multipleComponent")) {
          newArr.push({
            container_id: id,
            rect_id: index
          })
        }else{
          newArr=[{
            container_id: id,
            rect_id: index
          }]
        }
        sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
      }
      if (id !== null && index !== null && !shape.toLowerCase().includes("layoutComponent")) {
        // 放开了轮播图未激活时  在此激活的情况
        if (this.ids.container_id === id && this.ids.rect_id === index) {
          return
        }
        let param = {
          container_id: id,
          rect_id: index
        }
        this.$store.commit("states/changeActiveID", param)
        this.$store.commit("states/changeElementType", shape)
      }
      // 增加上层布局的层级
      // 添加setTimeout 是因为从外层通栏进来先执行去掉通栏的高层级
      // setTimeout(()=>{
      $(".layout-container.set_active").removeClass("set_active active")
      $(".page-layout-wrapper[data-level='top-level']").removeAttr("data-level")
      $(".layout-col.zIndex999").removeClass("zIndex999")
      $(".vue-grid-item").removeClass("zIndex999")
      $(this.$el).parents(".layout-col").addClass("zIndex999")
      $($(this.$el).parents(".page-layout-wrapper")[0]).attr("data-level", "top-level")
      // },500)
      setTimeout(()=>{
        $(this.$el).parents(".vue-grid-item").addClass("zIndex999")
      },500)
    },
    deactivateEv(id, index, shape) {
      if (this.$store.state.states.isOrderPattern) {
        return
      }
      if (!this.$store.state.states.elementType) {
        this.$store.commit("states/changeElementType", null)
      }
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: id,
        rect_id: index
      })
      // 增加上层布局的层级
      $(this.$el).parents(".layout-col").removeClass("zIndex999")
      $(this.$el).parents(".vue-grid-item").removeClass("zIndex999")
      $($(this.$el).parents(".page-layout-wrapper")[0]).removeAttr("data-level")
    },
    dragStopEv(arr, id, index) {
      let newRect = arr[0]
      const attr = this.getRectAttribute.call(this, this.ids).options
      const [oL, oT] = [attr.left, attr.top]
      const [nL, nT] = [newRect.left, newRect.top]
      let insertIndex = this.getInsertIndex(arr[4])
      if (this.layout?.options?.showRowColLayout && (oL !== nL || oT !== nT || this.dragExecute === false)) {
        if (insertIndex < 0) return
        let activeIndex = this.cellData.findIndex(item => item.rect_id === index)
        this.cellRect.splice(activeIndex, 1) // 删除当前拖拽元素
        this.cellRect.splice(insertIndex - 1, 0, index) //插入到鼠标放到的元素位置
        this.activateEv(id, index, attr.innerElement, activeIndex)
        this.insertIndex = null
      }
      this.dragging = false
      if (oL !== nL || oT !== nT) {
        this.dragExecute = false
        this.$store.commit("states/changeDragMode", true)
        this.dragExecute = true
        const componentIds = { container_id: id, rect_id: index }
        this.$store.commit("states/changeDragMode", false)
        const rulers = JSON.parse(localStorage.getItem("rulers"))
        if (Array.isArray(rulers)) {
          rulers.forEach(item => {
            if (item.type == "h") {
              if (Math.abs(newRect.top - item.site) < 10) {
                newRect.top = item.site
              }
              if (Math.abs(newRect.top + newRect.height - item.site) < 10) {
                newRect.top = item.site - newRect.height
              }
            }
            if (item.type == "v") {
              if (Math.abs(newRect.left - item.site) < 10) {
                newRect.left = item.site
              }
              if (Math.abs(newRect.left + newRect.width - item.site) < 10) {
                newRect.left = item.site - newRect.width
              }
            }
          })
        }
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.commit("states/changeDraggingStatus", false)
      }
    },
    mouseDownEv(param, id, index) {
      // 获取父元素的宽度
      this.getParentW = Number(window.getComputedStyle(this.$el).getPropertyValue("width").slice(0, -2))
      this.getParentH = Number(window.getComputedStyle(this.$el).getPropertyValue("height").slice(0, -2))
    },
    draggingEv(arr, id, index) {
      let newRect = arr[0]
      if (this.dragExecute) {
        if (!this.$store.state.states.dragStatus) this.$store.commit("states/changeDraggingStatus", true)
        const attr = this.getRectAttribute.call(this, this.ids).options
        const [oL, oT] = [attr.left, attr.top]
        const [nL, nT] = [newRect.left, newRect.top]
        if (oL !== nL || oT !== nT) {
          this.dragExecute = false
          this.$store.commit("states/changeDragMode", true)
        }
      }
      this.dragging = true
      if (this.layout?.options?.showRowColLayout) {
        this.insertIndex = this.getInsertIndex(arr[4])
      }
    },
    // 获取鼠标在当前元素上的索引
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) //鼠标在当前元素上的位置
      let left = Number(e.offsetX)
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect() // 当前元素位置
      let parentNode = this.getTargetParent(e.target, [])
      let targetVdr = this.getTargetParent(e.target,[],'vdr') // 获取当前vdr元素
      // if (this.startParent && this.startParent[0] !== parentNode[0]) { // 如果父级元素不同跨层级了禁止拖拽
      //   parentNode[0] = this.startParent[0] // 父级等于开始拖拽的父级
      //   if (this.getTargetParent(targetVdr[0])[0] !== this.startParent[0]) {
      //     targetVdr = this.getTargetParent(targetVdr[0],[],'vdr') // 目标元素取当前元素的父级
      //   }
      // }
      if (parentNode.length === 0) {// 鼠标移到外层时
        // _index = _this.cellData.length
        return -1
      }
      let allChild = [].filter.call(parentNode[0].children, item=>item.className.includes("vdr"))
      if (!allChild) return -1
      if (this.isAccordionLayout) {
        // 手风琴布局下有两层div
        let className = this.openIndex === this.index ? "accordionContent open" : "accordionContent default"
        for (var i = 0; i < allChild.length; i++) {
          if (allChild[i] && allChild[i].className === className) {
            allChild = allChild[i].children
            break
          }
        }
      }
      for (var i = 0; i < allChild.length; i++) {
        if (allChild[i] === targetVdr[0]) {
          _index = i
          break
        }
      }
      // if (_this.layout?.options?.rowColDirection === "vertical") {
      //   //垂直方向排列
      //   _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      // }
      // if (_this.layout?.options?.rowColDirection === "horizon") {
      //   //水平方向排列
      //   _index = left / targetPosition.width < 0.5 ? _index : _index + 1 // 超过元素宽度一半显示在后方，否则显示在前方
      // }
      if (this.isAccordionLayout) {
        // 手风琴布局中查找到的index是当前显示的组件的index，并不是当前布局中所有组件的index，需要通过rect_id去兑换
        let cellData = JSON.parse(JSON.stringify(this.cellData))
        cellData = cellData.filter(item=> this.openIndex === this.index ? item.options.isOpenState : !item.options.isOpenState)
        const rect_id = cellData[_index]?.rect_id
        _index = this.cellData.findIndex(item=>rect_id === item.rect_id)
      }
      return _index + 1
    },
    getTargetParent(e, res = [], className) {
      const parentNode = e?.parentNode
      let parentName = className ? className : "layout-cell-container"
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === parentName)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getTargetParent(parentNode, res, className)
        }
      } else {
        return res
      }
    },
    handleSwiperMode(mode, id, rectId) {
      this.$changeOptionsEV(mode, "swiperMode", false, null, { container_id: id, rect_id: rectId })
    },
    changeSize: _throttle(function (newRect, id, index, isResizeStop, rect) {
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: false })
      if(!newRect.isQuickSite){
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
      }
      if (rect.shape !== "cxAutoLayout" || (rect.shape === "cxAutoLayout" && (rect.options.widthType === "px" || !rect.options.widthType))) {
        this.$store.dispatch(this.request_prefix + "/setWidth", {
          container_id: id,
          rect_id: index,
          width: newRect.width
        })
      }
      if (rect.shape !== "cxAutoLayout" || (rect.shape === "cxAutoLayout" && (rect.options.heightType === "px" || !rect.options.heightType))) {
        this.$store.dispatch(this.request_prefix + "/setHeight", {
          container_id: id,
          rect_id: index,
          height: newRect.height
        })
      }

      if (isResizeStop) {
        this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { ...this.ids, flag: true })
      }
    }, 10),
    openMyContainerSet(containerId) {
      if (this.isBigScreenPreview()) return
      //打开画布设置
      let activeID = {
        container_id: containerId
      }
      this.$store.commit("states/changeToolBarStatus", true)
      this.$store.commit("states/changeElementType", "container")
      this.ids.container_id !== containerId && this.$store.commit("states/changeActiveID", activeID)
    },
    delMyContainer() {
      // 删除画布
      this.$store.dispatch(this.request_prefix + "/deleteContainer", this.id)
    },
    // 辅助线回调事件
    getRefLineParams(params) {
      const { vLine, hLine } = params
      let id = 0
      this.vLine = vLine.map(item => {
        item["id"] = ++id
        return item
      })
      this.hLine = hLine.map(item => {
        item["id"] = ++id
        return item
      })
    }
  }
}
</script>

<style scoped>
.layout-cell-container {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.is_full_rect {
  position: absolute;
  width: 100% !important;
  height: 100% !important;
}
.is_full_rect:not(.animate__animated) {
  top: 0 !important;
  left: 0 !important;
  transform: translate(0, 0) !important;
}
.empty-rect-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--thirdTextColor);
  pointer-events: none;
  .empty-rect-bg {
    width: 82px;
    height: 68px;
    margin: 0 auto 14px;
    background: url("../../../assets/images/empty_bay_window.png");
    background-size: contain;
  }
}
.ref-line {
  position: absolute;
  background-color: rgb(255, 0, 204);
  z-index: 9999;
}

.v-line {
  width: 1px;
}

.h-line {
  height: 1px;
}
::v-deep .loading-wrap{
  display: none;
}
.loading-newRect .loading-wrap {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  text-align: center;
  background: var(--defaultButtonHover);
  color: var(--thirdTextColor);
}
.loading-newRect .loading-wrap .loading-rect-box{
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.loading-newRect .loading-wrap .icon{
  display: inline-block;
  margin-bottom: 4px;
  font-size: 24px;
  transform: rotate(90deg);
  animation: rotation 1s linear infinite;
}
.loading-wrap  p{
  line-height: 20px;
  font-size: 16px;
}
.accordionContent {
  width: 100%;
  height: 100%;
}
.hidden {
  display: none;
}
</style>
